import React from 'react';
import classNames from 'classnames';

import { pushAddToListClick } from 'utils/gtm';
import { useDispatch } from 'react-redux';
import { showListsModal } from 'redux/modules/shopping-lists/actions/show-lists-modal';
import { RecipeProductTypes } from 'api/definitions/recipes/types';

import Button from '@johnlewispartnership/wtr-ingredients/ingredients/Button';
import { DocumentAdd } from '@johnlewispartnership/wtr-ingredients/foundations/icons';

import styles from './index.scss';

const addToListDefaultPropProducts = [];

const AddToList = ({ products = addToListDefaultPropProducts }) => {
  const dispatch = useDispatch();

  const lineNumbers = products.map(item => {
    const { lineNumber } = item.products[0];
    return lineNumber;
  });

  return (
    <div className={classNames(styles.container, 'no-print')}>
      <Button
        data-test-id="add-to-list"
        className={styles.lists}
        startIcon={<DocumentAdd />}
        theme="secondary"
        onClick={() => {
          pushAddToListClick();
          dispatch(showListsModal(lineNumbers.toString()));
        }}
      >
        Add to List
      </Button>
    </div>
  );
};

export default AddToList;

AddToList.propTypes = {
  products: RecipeProductTypes.products,
};
